import React from 'react';
import { Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  padding: 0 5px;
  border: 1px solid transparent;
  background-color: transparent;
`;

const StyledSaveOutlined = styled(SaveOutlined)`
  font-size: 16px;
`;

const TemplateSaving = ({ idUsingTemplate, template, onUpdate, onCreate, disabled = false }) =>
  template === undefined || idUsingTemplate === template.id ? (
    <StyledButton
      disabled={disabled}
      onClick={(e) => {
        if (template === undefined) {
          onCreate();
        } else {
          onUpdate();
        }
        e.stopPropagation();
        // для гашения фокуса после нажатия
        e.target.blur();
      }}
    >
      <StyledSaveOutlined />
    </StyledButton>
  ) : undefined;

export default TemplateSaving;
